export default "__VITE_ASSET__TRTRob7w__"